module.exports = __webpack_public_path__ + "static/img/6.f668dfd1.png";